import React from 'react';
import { FileText, Mail, Copy, Phone, Type, RefreshCw, GitCompare, Search, ArrowDownAZ, FileJson } from 'lucide-react';
import { ToolCard } from '../components/ToolCard';
const tools = [{
  title: 'Word & Character Counter',
  description: 'Count words, characters, sentences, and paragraphs',
  icon: Type,
  href: '/text-tools/word-counter'
}, {
  title: 'Case Converter',
  description: 'Convert text to UPPER, lower, Title, or Sentence case',
  icon: RefreshCw,
  href: '/text-tools/case-converter'
}, {
  title: 'Email Extractor',
  description: 'Extract email addresses from text',
  icon: Mail,
  href: '/text-tools/email-extractor'
}, {
  title: 'Paste as Plain Text',
  description: 'Strip all formatting from copied text',
  icon: FileText,
  href: '/text-tools/plain-text'
}, {
  title: 'Duplicate Line Remover',
  description: 'Remove duplicate lines from lists',
  icon: Copy,
  href: '/text-tools/duplicate-remover'
}, {
  title: 'Phone Number Extractor',
  description: 'Extract phone numbers from documents',
  icon: Phone,
  href: '/text-tools/phone-extractor'
}, {
  title: 'Text Diff Checker',
  description: 'Compare two texts and find differences',
  icon: GitCompare,
  href: '/text-tools/diff-checker'
}, {
  title: 'Find & Replace',
  description: 'Bulk find and replace text',
  icon: Search,
  href: '/text-tools/find-replace'
}, {
  title: 'Line Sorter',
  description: 'Sort lines alphabetically (A-Z)',
  icon: ArrowDownAZ,
  href: '/text-tools/line-sorter'
}, {
  title: 'CSV to JSON Converter',
  description: 'Convert CSV data to JSON format',
  icon: FileJson,
  href: '/text-tools/csv-to-json'
}];
export function TextToolsPage() {
  return <div className="container mx-auto px-4 py-8" data-id="element-728">
      <div className="mb-8" data-id="element-729">
        <h1 className="text-4xl font-bold mb-2" data-id="element-730">Text & Document Tools</h1>
        <p className="text-muted-foreground" data-id="element-731">
          Powerful text manipulation and extraction tools
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-732">
        {tools.map(tool => <ToolCard key={tool.href} {...tool} data-id="element-733" />)}
      </div>
    </div>;
}